import * as React from "react";
import { CircleCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
const inclusions = [{
  title: "Rapid Storm Response",
  description: "When severe weather strikes, our emergency teams are deployed immediately to secure your home and prevent further damage."
}, {
  title: "Hail Damage Expertise",
  description: "Specialized inspections to identify subtle hail impacts that can compromise your roof's integrity over time."
}, {
  title: "Wind Damage Repair",
  description: "Professional restoration for missing shingles, damaged siding, and structural issues caused by high-velocity winds."
}, {
  title: "Insurance Claim Support",
  description: "We work directly with your insurance provider, providing detailed documentation to ensure you receive full coverage."
}, {
  title: "Homeowner Advocacy",
  description: "Our team acts as your expert guide through the entire restoration process, from initial assessment to final sign-off."
}];
export default function StormDamageSection() {
  return <section data-section-id="261066" id="storm-damage-section" className="py-16 md:py-24 bg-background font-default text-foreground">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 font-default">
            Comprehensive Storm Recovery
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            Eagle Exteriors provides the reassurance and expertise you need after a storm. We handle the complex repairs and insurance hurdles so you can focus on your family.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {inclusions.map((item, i) => <Card key={i} data-index={i} className="bg-card border-border shadow-md hover:shadow-lg transition-shadow flex flex-row items-start p-6 gap-4 rounded-md">
              <CircleCheck className="size-6 text-secondary shrink-0 mt-0.5" aria-hidden="true" />
              <div>
                <h3 className="text-xl font-bold text-primary mb-2 font-default">
                  {item.title}
                </h3>
                <p className="text-foreground/80 leading-relaxed font-default">
                  {item.description}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}